/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { GuestGuard } from "../../components/guards";
import { COMPANY_LOGIN_PATH, USER_LOGIN_PATH } from "../../config/authPaths";
import SuspenseWrapper from "../SuspenseWrapper";

const CompanyLoginView = lazy(
  () => import("../../components/auth/CompanyLoginView"),
);
const UserLoginView = lazy(() => import("../../components/auth/UserLoginView"));

export const authRoutes: RouteObject[] = [
  {
    path: COMPANY_LOGIN_PATH,
    element: (
      <GuestGuard>
        <SuspenseWrapper>
          <CompanyLoginView />
        </SuspenseWrapper>
      </GuestGuard>
    ),
  },
  {
    path: USER_LOGIN_PATH,
    element: (
      <GuestGuard>
        <SuspenseWrapper>
          <UserLoginView />
        </SuspenseWrapper>
      </GuestGuard>
    ),
  },
];
